package one.healthium.log_food.data

import co.touchlab.kermit.Logger
import ifaandroid.feature.profile.log_food.generated.resources.Res
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import one.healthium.base.coroutines.IO
import one.healthium.base.preferences.AppPreferences
import one.healthium.db.dao.FoodDao

private const val FOOD_SUGGESTIONS_JSON = "files/food_suggestions_v3.json"

class FoodPreloadContent(
    private val foodDao: FoodDao,
    private val appPreferences: AppPreferences,
    private val json: Json,
    private val foodMapper: FoodMapper,
) {

    private val scope = CoroutineScope(Dispatchers.IO + SupervisorJob())

    fun preload() {
        scope.launch {
            try {
                if (appPreferences.latestFoodSuggestionsFile != FOOD_SUGGESTIONS_JSON) {
                    val bytes = Res.readBytes(FOOD_SUGGESTIONS_JSON)
                    val dtos = json.decodeFromString<List<FoodDto>>(bytes.decodeToString())
                    foodDao.replaceFoods(dtos.map(foodMapper::dtoToEntity))
                    appPreferences.latestFoodSuggestionsFile = FOOD_SUGGESTIONS_JSON
                    Logger.d("Preloaded food suggestions, (${dtos.size})")
                }
            } catch (e: Exception) {
                Logger.e("Failed to preload food suggestions", e)
            }
        }
    }
}